require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./contacts-bournemouth.json") })
        }
      }, "path---contacts-bournemouth");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---contacts-bournemouth!./.cache/json/contacts-bournemouth.json
// module id = 1398
// module chunks = 231608221292675